import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';

export const updatedataanasave = createAsyncThunk(
  'appointments/updatedataanasave',
  async (appt, { rejectWithValue }) => {
    try {
      if (!appt?.appointmentId) {
        return rejectWithValue('Missing appointmentId');
      }

      const url = `${baseUrl}/appointments/${appt.appointmentId}`;

      // Try UPDATE first
      try {
        const response = await axios.put(url, appt, {
          headers: { 'Content-Type': 'application/json' },
        });

        return response.data;
      } catch (err) {
        // If not found → create new
        if (err.response?.status !== 404) {
          throw err;
        }

        const createResponse = await axios.post(
          `${baseUrl}/appointments/save`,
          appt,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        console.log('✅ Appointment created:', createResponse.data);
        return createResponse.data;
      }
    } catch (err) {
      console.error('❌ Save error:', err.response?.data || err.message);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
